import { useCallback } from 'react'

export const useLogout = (
  kedo: any,
  setRedirect: (v: boolean) => void
) => {
  return useCallback(() => {
    const tokenData = localStorage.getItem('tokenData')
    if (!tokenData) {
      localStorage.clear()
      setRedirect(true)
      return
    }

    const data = JSON.parse(tokenData)
    const lastVisit = new Date(parseInt(data.iat) * 1000)

    kedo.api()
      .get('/logout_cookie')
      .finally(() => {
        localStorage.clear()
        localStorage.setItem(
          'lastVisit',
          lastVisit.getTime().toString()
        )
        setRedirect(true)
      })
  }, [kedo, setRedirect])
}